if not App.angularApp?
    return

EMAIL_REGEXP = /^([\w._%+-]+@[\w.-]+\.\w{2,6})?$/

App.angularApp.directive 'mfIsEmail', () ->
    return {
        require: 'ngModel'
        link: (scope, element, attrs, ngModel) =>
            ngModel.$validators.mfIsEmail = (modelValue, viewValue) =>
                if ngModel.$isEmpty(modelValue)
                    return true

                if EMAIL_REGEXP.test(viewValue)
                    return true

                return false
    }
